import { makeStyles, TableSortLabel, Typography } from "@material-ui/core";

export const EnchancedSortLabel = ({
  columnId,
  columnLabel,
  hasSortLabel,
  handleChange,
  ordering,
}: {
  columnId: string;
  columnLabel: string;
  hasSortLabel: boolean;
  handleChange: (sortId: string | undefined, cellId: string) => void | undefined;
  ordering: string;
}) => {
  const classes = useStyles();

  const isActive = ordering?.replace("-", "") === columnId;
  const arroeDirection =
    ordering?.replace("-", "") === columnId && ordering?.includes("-") ? "desc" : "asc";

  return (
    <>
      {hasSortLabel ? (
        <TableSortLabel
          disabled={!hasSortLabel}
          active={isActive}
          direction={arroeDirection}
          onClick={() => handleChange(ordering, columnId)}
          className={classes.labelwithArrow}
        >
          <Typography style={{ textWrap: "nowrap" }} className={classes.fontWeight}>
            {columnLabel}
          </Typography>
        </TableSortLabel>
      ) : (
        <Typography style={{ textWrap: "nowrap" }} className={classes.fontWeight}>
          {columnLabel}
        </Typography>
      )}
    </>
  );
};

export const useStyles = makeStyles((theme) => ({
  labelwithArrow: {
    "& .MuiSvgIcon-root": {
      opacity: 0.2,
      color: "black",
    },
    "&.MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon": {
      opacity: 1,
      color: "black",

    },
    "&.Mui-disabled": {
      "& .MuiSvgIcon-root": {
        opacity: 0,
      },
    },
  },
  fontWeight: {
    fontWeight: 600,
    fontSize: "16px",
  },
}));
